<template>
  <modal data-test="video-embed-modal" class="modal" name="video" height="auto" width="500" :adaptable="true" ref="video-modal" @before-open="beforeOpen">
    <h1 class="modal-heading">Embed Video</h1>
    <h2 class="modal-subheading">Copy and paste a URL from Youtube or Vimeo.</h2>
    <div class="auth-form">
      <ff-input
        placeholder="Youtube or Vimeo Link"
        data-test="video-input"
        type="url"
        name="email"
        :ref="'emailInput'"
        value
        required
        autofocus
        v-model="url"
        @keypress.enter.prevent.stop="submit"
      />
      <br/>
      <ff-button
        data-test="video-submit"
        type="submit"
        :text="'Save'"
        :action="submit"
      />
      <ff-button
        data-test="video-cancel"
        :text="'Cancel'"
        :pattern="2"
        :action="cancel"
      />
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex'

import FFButton from '../DesignSystem/FFButton'
import FFInput from '../DesignSystem/FFInput'

export default {
  name: 'modal-video',
  components: {
    'ff-button': FFButton,
    'ff-input': FFInput
  },
  data () {
    return {
      url: '',
      command: null
    }
  },
  computed: {
    ...mapState(['user', 'channel']),
    youtubeOrVimeo () {
      let youtube = this.youtubeParser(this.url) ? this.youtubeParser(this.url) : null,
          vimeo = this.vimeoParser(this.url) ? this.vimeoParser(this.url) : null
      return youtube || vimeo
    }
  },
  methods: {
    beforeOpen (event) {
      this.command = event.params.command
    },
    submit (e) {
      if (e) e.stopPropagation()
      const data = {
        command: this.command,
        data: {
          src: this.youtubeOrVimeo
        }
      }
      return this.$emit('callback', data)
    },
    youtubeParser(url) {
      // eslint-disable-next-line
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
      const match = url.match(regExp)
      let id = match && match[7].length === 11 ? match[7] : false;
      if (id) return `https://www.youtube.com/embed/${id}`
    },
    vimeoParser(url) {
      let str = url
      // eslint-disable-next-line
      const result = str.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
      if (result) {
        return result[0].includes('player') ? `https://${result[0]}` : `https://player.vimeo.com/video/${result[1]}`
      }
    },
    cancel () {
      this.$modal.hide('video')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  ::v-deep
  .vm--modal {
    padding: $unit-3;
    box-sizing: border-box;
    border-radius: $borderRadius;
  }

</style>
